module.exports = __webpack_public_path__ + "img/symbol_6.7b76c52a.png";